module.exports = __webpack_public_path__ + "2defc4ee87ae1ea03f726493acdea0c4.jpg";